import classNames from "classnames";
import React from "react";
import { TEMPLATE_CONTAINER_HEIGHT, TEMPLATE_CONTAINER_WIDTH } from "shared/utils/styleConstants";

interface TemplateContainerProps {
  children: React.ReactNode;
  continerRef: React.RefObject<HTMLDivElement>;
  className?: string;
  hasContainerBorder: boolean;
  hasInvisibleArea?: boolean;
  styleType?: string;
}

export default function TemplateContainer({
  children,
  continerRef,
  hasContainerBorder,
  styleType,
  hasInvisibleArea
}: TemplateContainerProps) {
  return (
    <div
      id="template"
      ref={continerRef}
      className={classNames("templateContainer_templateArea", styleType)}
      style={{
        width: TEMPLATE_CONTAINER_WIDTH,
        height: TEMPLATE_CONTAINER_HEIGHT,
        border: hasContainerBorder ? "1px dashed var(--secondary)" : "none"
      }}>
      {hasInvisibleArea && <div className="templateContainer_invisibleArea"></div>}
      {children}
    </div>
  );
}
